import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import React, { useRef, useState } from 'react';
import LoanForm, { LoanFormRef, LoanFormValues } from './LoanForm';

type CreateLoanProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (values: LoanFormValues) => Promise<void>;
};

const CreateLoanModal: React.FC<CreateLoanProps> = ({
  isOpen,
  toggle,
  onSubmit,
}: CreateLoanProps) => {
  const { messages } = useTypedIntl();

  const formRef = useRef<LoanFormRef>(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values: LoanFormValues) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppModalContainer
      title={messages['common.addNewLoan']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => formRef.current?.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
    >
      <LoanForm formRef={formRef} onSubmit={handleSubmit} />
    </AppModalContainer>
  );
};

export default CreateLoanModal;
